import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const MIN_ATTEMPT = 1
const MAX_ATTEMPT = 3

const EscalationAttemptField = ({ onSave, defaultAttempt = MAX_ATTEMPT }) => {
  const { t } = useTranslation(['on-call-schedule'])
  const [attempt, setAttempt] = useState(defaultAttempt)
  return (
    <React.Fragment>
      <span className="escalations-order__item--notifications-text escalations-order__item--notifications-info">
        {t('on-call-schedule:emergencyNotifications.callAttempts', { count: attempt })}
      </span>
      <input
        className="escalations-order__item--notifications-input"
        type="number"
        min={MIN_ATTEMPT}
        max={MAX_ATTEMPT}
        value={attempt}
        onChange={(e) => {
          const preparedValue = parseInt(e.target.value)
          if (preparedValue) {
            return setAttempt(preparedValue > MAX_ATTEMPT ? MAX_ATTEMPT : preparedValue)
          }
          return setAttempt(MIN_ATTEMPT)
        }}
      />
      <button
        className="button button-black escalations-order__item--notifications-btn"
        onClick={() => onSave(attempt)}
      >
        {t('on-call-schedule:emergencyNotifications.saveLowercase')}
      </button>
    </React.Fragment>
  )
}

EscalationAttemptField.propTypes = {
  onSave: PropTypes.func,
  defaultAttempt: PropTypes.number,
}

export default EscalationAttemptField
